/**
 * TODO: Fetch catalog from SDK.
 * TODO: make sure what is in IAPReward.json always matches this
 * WARNING: these values are also used in tracking
 */
export enum ProductId {
    DEPRECATED_COINS_20k = '001',
    DEPRECATED_COINS_14k = '003',
    DEPRECATED_COINS_35k = '004',
    DEPRECATED_SPECIAL_OFFER = '006',
    DEPRECATED_PRODUCT_7 = '007',
    DEPRECATED_STARTER_PACK_V2 = 'starterpack_v2_0.99',
    DEPRECATED_COINS_240k_V2 = '240000coins_v2_14.99',
    DEPRECATED_SUNDAY_OFFER_V1 = 'sunday_offer_29.99',

    COINS_60k = '002',
    SPECIAL_OFFER = '005',
    STARTER_PACK_V3 = 'starterpack_v3_1.99',
    JOKER_DEAL_V2 = 'jokerdeal_v2_19.99',
    COINS_1mil_V2 = '1000000coins_v2_44.99',
    COINS_10K = '10000coins_0.99',
    COINS_120K = '120000coins_8.99',
    SUNDAY_OFFER_V2 = 'sunday_offer_v2_34.99',
    SUNDAY_OFFER_V2_44_99 = 'sunday_offer2_44.99',
    PAYER_REACTIVATION_OFFER = 'reactivation_offer_14.99',
    PAYER_REACTIVATION_OFFER_2 = 'reactivation_offer_2_24.99',
    PAYER_REACTIVATION_OFFER_3 = 'reactivation_offer_3_34.99',
    PREMIUM_SPIN = 'premium_spin_1.99',
    FARM_UNLOCK_AREA = 'slot_unlock1_1.99',
    XMAS_2021_OFFER = 'event_offer_9.99',


}
